import {useEffect, useState} from 'react'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {notificationSelector, setNotification} from 'src/redux/slices/notificationSlices'
import dateformat from 'src/utils/dateformat'
import {CustomModal} from '../CustomModal'
import {LuCalendar} from 'react-icons/lu'

export const NotificationDetailModal = () => {
  const dispatch = useAppDispatch()
  const {notification} = useAppSelector(notificationSelector)
  const [openModal, setOpenModal] = useState(false)

  const handleCloseModal = () => {
    setOpenModal(false)
    dispatch(setNotification(null))
  }

  useEffect(() => {
    if (!notification) return
    // if (notification.type !== 'transaction') return
    setOpenModal(true)
  }, [notification])

  useEffect(() => {
    return () => {
      dispatch(setNotification(null))
    }
  }, [])

  if (!notification) return null

  return (
    <CustomModal
      title={notification.title}
      show={openModal}
      size='lg'
      centered
      onHide={handleCloseModal}
    >
      <div className='d-flex flex-row align-items-center mb-3' style={{gap: '0.5rem'}}>
        <LuCalendar size={16} color='#818181' />
        <div style={{color: '#818181'}}>{dateformat(notification.created_at)}</div>
      </div>

      <div style={{fontSize: '1.15rem'}}>{notification.body}</div>
    </CustomModal>
  )
}
